import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Check, PriorityHigh, Warning } from '@mui/icons-material'
import './WorkflowTask.scss'
import { TaskStatus } from '../../../pages/vdo-ticket/services/TaskStatus';

const WorkflowStatusIcon = (props) => {
    return (
        <div className='workflow-status'>
            <div className={classnames('icon-holder', {
                'is-grey': props.status === TaskStatus.NOT_STARTED,
                'is-green': props.status === TaskStatus.COMPLETE,
                'is-yellow': props.status === TaskStatus.IN_PROGRESS || props.status === TaskStatus.READY_TO_FILE || props.status === 'StatusReset',
                'is-red': props.status === TaskStatus.FAILED || props.status === TaskStatus.ERROR
            })}>
                {props.status === 'CompletedSuccessfully' &&
                    <Check />
                }
                {props.status === 'StatusReset' &&
                    <Warning/>
                }
                {(props.status === TaskStatus.IN_PROGRESS || props.status === TaskStatus.FAILED ||
                  props.status === TaskStatus.ERROR || props.status === TaskStatus.READY_TO_FILE) &&
                    <PriorityHigh />
                }
            </div>
        </div>
    )
}

WorkflowStatusIcon.propTypes = {
    status: PropTypes.string
}

export default WorkflowStatusIcon;
